import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/Notification_Read.svg"

const NotificationRead: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 24 24'} component={Icon} {...props} fill="currentColor" />
export default NotificationRead
